import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useStores} from "../../../../stores/Context";
import {useParams} from "react-router-dom";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const WidgetConsignesContentPhotoList = () => {
    const {id, ent} = useParams();
    const Modal = withReactContent(Swal);
    const [isLoad, setIsLoad] = useState(false);
    const [listPhotos, setListPhotos] = useState([]);
    const {widgetStore} = useStores();

    axios.defaults.headers.common['Authorization'] = 'Bearer ' + widgetStore.getCookie("current_apiToken");

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + '/api/getAllConsignesPhotosByIdTotem/' + widgetStore.idTotem
        ).then((res) => {
            setListPhotos(res.data)
            setIsLoad(false)
        });
    }, [isLoad])

    const handleDeletePhoto = (id) => {
        Modal.fire({
            width: 500,
            allowOutsideClick: false,
            text: 'Etes-vous sur de vouloir supprimer cette Photo ?',
            showDenyButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Valider',
            confirmButtonColor: '#1976d2',
            denyButtonText: 'Annuler',
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(process.env.REACT_APP_API_URL + '/api/deletePhoto', {
                        id: id
                    }).then((res) => {
                        setIsLoad(true)
                })
            }
        });
    }

    return (
        <div>
            <div className={"consignePhotoContent"}>
                {
                    listPhotos.length > 0 ? (
                            listPhotos.map((data) => (
                                <div  className={"consignePhotoImg"}>
                                    <div>
                                        <img  src={data.image} style={{width: "100%", height:"17em"}}/>
                                    </div>
                                    <div className={"imgFooter"}>
                                <span style={{marginLeft: '0.5em'}}>
                                    {'Ajouté le '+ data.created_at}
                                </span>
                                        <FontAwesomeIcon className={"iconDeleteImg"} icon={faTrash} onClick={() => handleDeletePhoto(data.id)}/>
                                    </div>
                                </div>
                            ))
                        ) : 'Aucune photo enregistrée'

                }
            </div>
        </div>
    );
};

export default WidgetConsignesContentPhotoList;